/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { useState, useEffect } from 'react';

export const useDelayDebounce = (val, delayTime) => {
  const [delayDebouncedVal, setDelayDebouncedVal] = useState(val);
  useEffect(() => {
    // debounced val after set delay
    const timeoutHandler = setTimeout(() => {
      setDelayDebouncedVal(val);
    }, delayTime);
    // clear the timeout on val changes (also when delay changes)
    // This prevents debounced val from the update if value is changed in the delay zone. Timeout gets cancled and restart happens.
    return () => {
      clearTimeout(timeoutHandler);
    };
  }, [val, delayTime]);
  return delayDebouncedVal;
};
